import * as THREE from "three";
import Experience from "./Experience.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

const pathCurve = new THREE.CatmullRomCurve3([
  new THREE.Vector3(5.2, 0.6, -5.2),
  new THREE.Vector3(-4.9, 5.0, -2.5),
  new THREE.Vector3(-5.2, 3.0, 4.2),
  new THREE.Vector3(6.3, -1.2, 3.6),
  new THREE.Vector3(-0.8, -10.5, 0.5),
]);

export default class Camera {
  constructor(_options) {
    // Options
    this.experience = new Experience();
    this.config = this.experience.config;
    this.debug = this.experience.debug;
    this.time = this.experience.time;
    this.sizes = this.experience.sizes;
    this.targetElement = this.experience.targetElement;
    this.scene = this.experience.scene;
    this.index = 0;

    // Set up
    this.mode = "debug"; // defaultCamera \ debugCamera

    this.setInstance();
    this.setModes();

    window.addEventListener("wheel", (event) => {
      if (event.deltaY < 0) {
        this.index--;
        if (this.index < 0) this.index = 0;
      } else if (event.deltaY > 0) {
        this.index++;
        if (this.index > 50) this.index = 50;
      }

      let p = this.index / 50;
      let position = pathCurve.getPointAt(p);

      this.modes.debug.instance.position.copy(position);
    });
  }

  setInstance() {
    // Set up
    this.instance = new THREE.PerspectiveCamera(
      75,
      this.sizes.width / this.sizes.height,
      0.1,
      100
    );

    this.instance.rotation.reorder("YXZ");

    this.scene.add(this.instance);
  }

  setModes() {
    this.modes = {};

    // Default
    this.modes.default = {};
    this.modes.default.instance = this.instance.clone();
    this.modes.default.instance.rotation.reorder("YXZ");
    this.modes.default.instance.position.set(5.2, 0.6, -5.2);

    // Debug
    this.modes.debug = {};
    this.modes.debug.instance = this.instance.clone();
    this.modes.debug.instance.rotation.reorder("YXZ");
    this.modes.debug.instance.position.set(5.2, 0.6, -5.2);

    this.modes.debug.orbitControls = new OrbitControls(
      this.modes.debug.instance,
      this.targetElement
    );
    this.modes.debug.orbitControls.enabled = this.modes.debug.active;
    this.modes.debug.orbitControls.screenSpacePanning = true;
    this.modes.debug.orbitControls.enableKeys = false;
    this.modes.debug.orbitControls.enableZoom = false;
    this.modes.debug.orbitControls.enableRotate = false;
    this.modes.debug.orbitControls.enablePan = true;
    this.modes.debug.orbitControls.zoomSpeed = 0.25;
    this.modes.debug.orbitControls.enableDamping = true;
    this.modes.debug.orbitControls.update();
  }

  resize() {
    this.instance.aspect = this.config.width / this.config.height;
    this.instance.updateProjectionMatrix();

    this.modes.default.instance.aspect = this.config.width / this.config.height;
    this.modes.default.instance.updateProjectionMatrix();

    this.modes.debug.instance.aspect = this.config.width / this.config.height;
    this.modes.debug.instance.updateProjectionMatrix();
  }

  update() {
    // Update debug orbit controls
    this.modes.debug.orbitControls.update();
    
    // Apply coordinates
    this.instance.position.copy(this.modes[this.mode].instance.position);
    this.instance.quaternion.copy(this.modes[this.mode].instance.quaternion);
    this.instance.updateMatrixWorld(); // To be used in projection
  }

  destroy() {
    this.modes.debug.orbitControls.destroy();
  }
}
